/**
 * Pixel width of a single grid column, mirroring react-grid-layout's own
 * `calcGridColWidth` so a controlled resize lands on the same grid units the
 * library renders.
 */
export function calcColumnWidth(
  containerWidth: number,
  cols: number,
  marginX: number,
  containerPaddingX = 0,
): number {
  return (containerWidth - marginX * (cols - 1) - containerPaddingX * 2) / cols;
}

/** Convert a pixel delta into whole grid units (columns or rows). */
export function pixelDeltaToUnits(deltaPx: number, unitPx: number, gapPx: number): number {
  const step = unitPx + gapPx;
  if (step <= 0) return 0;
  return Math.round(deltaPx / step);
}

export function clampUnits(value: number, min: number, max: number): number {
  if (max < min) return min;
  return Math.min(Math.max(value, min), max);
}
